import { styled } from '@mui/material';
import { Grid } from '@mui/system';

const PREFIX = 'UserProfile';

export const userProfileClasses = {
  container: `${PREFIX}-container`,
  emailIconStyle: `${PREFIX}-emailIconStyle`,
  textField: `${PREFIX}-textField`,
};

export const UserProfileStyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${userProfileClasses.container}`]: {
    textAlign: 'center',
    padding: 20,
    border: `0.1em solid ${theme.palette.primary.main}`,
    cursor: 'pointer',
    borderRadius: '0.2em',
    fontFamily: theme.typography.secondaryFont,
  },

  [`& .${userProfileClasses.emailIconStyle}`]: {
    fontSize: '2rem',
  },

  [`& .${userProfileClasses.textField}`]: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      color: theme.palette.primary[700],
      fontSize: '1rem',
    },
  },
}));
